import React, { memo, useMemo } from 'react';
import { TableCell, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { StyledAvatar } from '../../StyledAvatar/StyledAvatar';
import { StyledBox, StyledChip, StyledTableRow } from './ViolationRow.styles';

/**
 * Component to render a single violation row
 */
const ViolationRow = memo(({ violation, onViolationClick, isSelected }) => {
  const message = violation.type.message;

  // Format the data to improve readability
  const formattedDate = useMemo(() => {
    return violation.timestamp ? dayjs(violation.timestamp).format('ddd, MMM DD ') : 'N/A';
  }, [violation.timestamp]);

  return (
    <StyledTableRow
      selected={isSelected}
      onClick={() => onViolationClick && onViolationClick(violation)}
      role="button"
      aria-label={`Violation by ${violation.displayName || 'Unknown'}`}
    >
      <TableCell>
        <StyledBox>
          <StyledAvatar src={violation.profileImageUrl} alt={violation.displayName || ''} size="small" />
          <Typography variant="bodyRegular">{violation.displayName || 'Unknown'}</Typography>
        </StyledBox>
      </TableCell>
      <TableCell>
        <Typography variant="bodyRegular">{message}</Typography>
      </TableCell>
      <TableCell>
        <StyledChip label={violation.status || 'Unknown'} variant="outlined" />
      </TableCell>
      <TableCell>
        <Typography variant="bodyRegular">{formattedDate}</Typography>
      </TableCell>
    </StyledTableRow>
  );
});

export default ViolationRow;
